import React, {useState} from "react";
import { graphql, Subscription } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Loading from "../../components/Loading";
import Form, {DEFAULT_REPLACEMENT_REASON} from "./ReplacePackagesForShippingOrderForm";
import {ON_ORDER_UPDATED, ORDER_TAGS} from "../../queries/shipping";
import {cancelReplacePackagesForShippingOrder} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import MessageBus from "../../lib/MessageBus";


const ReplacePackagesForShippingOrderFormContainer = (props) => {
  const [errors, setErrors] = useState([]);
  
  const [replacementOrderId, setReplacementOrderId] = useState(null);
  // Processing is longer than just sending the mutation, as we then have to
  // wait until the current order is updated (meaning the replacement is ready)
  // to then redirect to the replacement order.
  const [processing, setProcessing] = useState(false);

  function handleSubmit(data) {
    setProcessing(true);

    const updatedValues = {
      orderId: props.orderId,
      packageIds: props.packageIds,
      replacementReason: data.get("replacementReason"),
      includeTags: data.get("includeTags") === true,
    }
    
    return props.requestReplacementOrder(updatedValues)
      .then((response) => {
        if (response.data.requestReplacementOrder.errors.length > 0) {
          const errors = createValidationErrors(response.data.requestReplacementOrder.errors);
          setErrors(errors);

          // Error => no need to disable buttons anymore
          setProcessing(false);
        } else {
          // No need to enable buttons
          const replacementOrderId = response.data.requestReplacementOrder.replacementOrderId;

          setReplacementOrderId(replacementOrderId);
          return replacementOrderId;
        }
      })
      .catch((err) => {
        setErrors(createErrors(err));

        // Error => no need to disable buttons anymore
        setProcessing(false);
      });
  }

  function handleCancel() {
    props.cancelReplacePackagesForShippingOrder();
  }

  return (
    <>
      {/* Keep track of order updates so we can redirect to replacement order */}
      <Subscription
        subscription={ON_ORDER_UPDATED}
        variables={{ orderId: props.orderId }}
      >
      {({ data, loading }) => {
        // We get the replacement id right away when requesting for replacement
        // but this doesn't mean the order is ready, so we have to wait for the
        // subscription to confirm to us that it's good.
        if (!loading && replacementOrderId && data && data.updatedShippingOrder) {
          // Redirect to replacement order
          MessageBus.publish("navigation", "goto", {
            url: `/shipping/orders/${replacementOrderId}`
          });
          handleCancel();
        }
        
        return processing && <Loading />;
      }}
    </Subscription>
    <Form
      errors={errors}
      // message={"Do you want to send the replacements right away or do you want to be able to review the replacement order beforehand?"}
      message="You will be redirected to the replacement order, where you will need to review, reserve the stock and send the order."
      tags={(props.data && props.data.shippingOrder && props.data.shippingOrder.tags) || []}
      initialValues={{replacementReason: DEFAULT_REPLACEMENT_REASON, includeTags: false}}
      submitLabel="Create replacement order"
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      processing={processing}
      />
    </>
  );
}


const REQUEST_REPLACEMENT_ORDER = gql`
  mutation requestReplacementOrder($data: RequestReplacementOrderInput!) {
    requestReplacementOrder(input: $data) {
      replacementOrderId
      errors { key message }
    }
  }
`;

const withMutation = compose(
  // The order's tags decide whether the admin is asked to carry them over.
  graphql(ORDER_TAGS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        orderId: props.orderId
      }
    })
  }),
  graphql(REQUEST_REPLACEMENT_ORDER, {
    props: ({ mutate }) => ({
      requestReplacementOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelReplacePackagesForShippingOrder})(withMutation(ReplacePackagesForShippingOrderFormContainer));